module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/recommend_1_04-d161d41a29e825ac5d58f5dbfd793e57.jpg";